/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Support_Track_Hint_PrefixInputs */

const en_common_support_track_hint_prefix = /** @type {(inputs: Common_Support_Track_Hint_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can track replies in`)
};

const zh_common_support_track_hint_prefix = /** @type {(inputs: Common_Support_Track_Hint_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交后可前往`)
};

/**
* | output |
* | --- |
* | "You can track replies in" |
*
* @param {Common_Support_Track_Hint_PrefixInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_support_track_hint_prefix = /** @type {((inputs?: Common_Support_Track_Hint_PrefixInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Support_Track_Hint_PrefixInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_support_track_hint_prefix(inputs)
	return zh_common_support_track_hint_prefix(inputs)
});
export { common_support_track_hint_prefix as "common.support.track_hint_prefix" }